import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=b37ebfee&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"
import style0 from "./icon.vue?vue&type=style&index=0&id=b37ebfee&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangxinfan/Documents/work/hqxkj/project/WSXS2025004F_平台运营服务养殖证示范化管理系统分包-水产三期/01code/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b37ebfee')) {
      api.createRecord('b37ebfee', component.options)
    } else {
      api.reload('b37ebfee', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=b37ebfee&", function () {
      api.rerender('b37ebfee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon.vue"
export default component.exports